import { EndUserComponent, EndUserPages } from '@aurora/shared-types/pages/enums';
import dynamic from 'next/dynamic';
import React from 'react';
import type { BreadcrumbItem } from '../../../components/context/BreadcrumbContext/BreadcrumbContext';
import BasePage from '../../../components/page/BasePage/BasePage';
import { TermsOfServiceType } from '../../../components/termsofservice/TermsOfServiceHelper';
import useTranslation from '../../../components/useTranslation';

const TermsOfServiceActionMenu = dynamic(
  () =>
    import('../../../components/termsofservice/TermsOfServiceActionMenu/TermsOfServiceActionMenu')
);

/**
 * Terms of Service Page. Allows the user to accept terms of service.
 *
 * @author Dolan Halbrook, Amit Agrawal
 */
const TermsOfServicePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { formatMessage } = useTranslation(EndUserComponent.TERMS_OF_SERVICE_PAGE);

  /**
   * This function returns the array of breadcrumbs for the TemsOfService Page to be displayed
   * @param breadcrumbs the breadcrumb item that is to be displayed
   * @returns array of the breadcrum items
   */
  function decorateBreadcrumbs(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    return [
      ...breadcrumbs,
      {
        id: 'page:TermsOfServicePage',
        title: formatMessage('breadCrumbTitle')
      }
    ];
  }

  /**
   * Renders the terms of service action.
   * @returns React Element
   */
  function renderActionMenu(): React.ReactElement {
    return <TermsOfServiceActionMenu termsOfServiceType={TermsOfServiceType.TERMS_OF_SERVICE} />;
  }
  return (
    <BasePage
      pageId={EndUserPages.TermsOfServicePage}
      nextSeoProps={{ noindex: true, nofollow: true }}
      decorateBreadcrumbs={decorateBreadcrumbs}
      breadcrumbActionComponents={[renderActionMenu]}
    />
  );
};
export default TermsOfServicePage;
